import Lottie from 'lottie-react';
import React from 'react';

// Data
import { animationData } from './data';

export const Animation = () => <Lottie animationData={animationData} />;
